module.exports = __webpack_public_path__ + "static/colab_home-bca1bf8c4e42a2f2a0420e0e9c4db216.jpg";